import get from 'lodash/get'

import { prepareFormData } from '../helpers/data'
import { useQuery } from 'components/graphql'
import { NEW_RECORD_PATH } from 'config/consts'
import { useTranslation } from 'react-i18next'

const useItemData = ({ itemDataProps = {}, navBarProps: { getLabel, hideLabel } = {}, skipQuery, ...props }) => {
	const { addNewRecord: { status: newRecordStatus, copyId } = {} } = props
	const { sectionData = {}, subsectionData, recordId: id } = props
	const { fields, subsectionQuery, queryItemIdPath } = subsectionData
	const dataQuery = subsectionQuery || sectionData.itemQuery
	const [t] = useTranslation()
	let itemViewProps = {
		variables: { id/*: newRecordStatus === 'RECORD_ADDED' ? NEW_RECORD_PATH : id*/ },
		skip: newRecordStatus === 'NEW_RECORD' || !id || skipQuery,
		query: dataQuery,
		...itemDataProps
	}

	// if(newRecordStatus === 'RECORD_ADDED') {
	// 	itemViewProps.fetchPolicy = 'cache-only'
	// }

	if (newRecordStatus === 'COPY_RECORD') {
		itemViewProps.skip = false
		itemViewProps.itemId = copyId
		itemViewProps.variables.id = copyId
		itemViewProps.fetchPolicy = 'cache-first'
	}
	const queryResult = useQuery(dataQuery, itemViewProps)
	const { data, loading, error, queryField, networkStatus } = queryResult
	if (!dataQuery) {
		return {}
	}
	/*const itemData = data[queryField]
	const isActualData = itemData && (Number(id) === Number(itemData.id) || itemData.id === NEW_RECORD_PATH)
	const isNewRecordPage = id === NEW_RECORD_PATH*/
	let itemData = data[queryField]
	if (skipQuery) {
		itemData = props.itemData || {}
	}
	const itemId = queryItemIdPath ? get(itemData, queryItemIdPath) : get(itemData, 'id')
	const isActualData = itemData && (Number(id) === Number(itemId) || itemId === NEW_RECORD_PATH)
	const isNewRecordPage = id === NEW_RECORD_PATH
	let out = {
		queryResult
	}
	if (!isActualData && error && error.networkError) {
		out.status = 'NETWORK_ERROR'
	} else if (!id) {
		out.status = 'NULL'
	} else if (!itemData && !loading && !isNewRecordPage) {
		out.status = 'NO_ITEM'
	} else {
		out.status = 'ITEM'
		out.isLoading = skipQuery ? false : (networkStatus !== 7 && ((!isActualData || (!itemData && loading)) && !isNewRecordPage))
		out.formData = {}
		switch (newRecordStatus) {
			case 'COPY_RECORD':
				// Copy fields to new record only from first subsection because other subsections are disabled. Whole data will be copyied on server.
				// Don't copy unique fields if they exists.
				const availableFields = Array.isArray(sectionData.uniqueFields)
					? sectionData.subsections[0].fields.filter(field => sectionData.uniqueFields.indexOf(field) < 0)
					: sectionData.subsections[0].fields
				out.formData = prepareFormData(itemData, availableFields)
				if (out.formData.name) {
					out.formData.name = `${out.formData.name} - copy`
				}
				break
			case 'NEW_RECORD':
				out.formData = sectionData.newRecordsDefaults
				break
			default:
				out.formData = prepareFormData(itemData, fields)
				break
		}
		out.labelInfo = sectionData.fieldsInLabel
			? sectionData.fieldsInLabel.reduce((outArr, { field, label }) => itemData && itemData[field] ? [...outArr, label] : outArr, [])
			: null
		if (!hideLabel) {
			if (out.isLoading) {
				out.itemLabel = 'Wird geladen...'
			} else if (newRecordStatus === 'NEW_RECORD') {
				out.itemLabel = t('product_section.strings.new_group')
			} else if (typeof getLabel === 'function') {
				out.itemLabel = getLabel(itemData)
			} else if (itemData) {
				out.itemLabel = itemData.name
			}
		}

		out = {
			...out,
			itemData: itemData || {}
		}
	}
	return out
}
export default useItemData
